import Model from './Model'

export default class Contact extends Model {
    resource() {
        return 'contact'
    }

    get user_email()
    {
        return this.lead.email
    }

}
